import { render, staticRenderFns } from "./AssignPitchDialog.vue?vue&type=template&id=13828f7f&scoped=true&"
import script from "./AssignPitchDialog.vue?vue&type=script&lang=js&"
export * from "./AssignPitchDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignPitchDialog.vue?vue&type=style&index=0&id=13828f7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13828f7f",
  null
  
)

export default component.exports